import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { LeaveYourPhonePopupWidget } from '@fttb/common/components';
import { compose } from 'redux';
import { isPageTypeFmc } from "../../store/blocks/selectors";
import { getCallbackRequestData, getSelfCallingPopupData } from "../../store/shared/selectors";
import { selectIsFttbPersonalVerificationCheckboxEnable } from "../../store/callbackRequest/selectors";
export var LeaveYourPhonePopup = compose(connect(function (state) {
  var _getSelfCallingPopupD;
  return {
    backCallPopupData: getCallbackRequestData(state),
    isConvergent: isPageTypeFmc(state),
    redesign: true,
    selfCallingPopupData: getSelfCallingPopupData(state),
    shouldRender: !!((_getSelfCallingPopupD = getSelfCallingPopupData(state)) !== null && _getSelfCallingPopupD !== void 0 && _getSelfCallingPopupD.showSelfCallingPopup),
    showActionBar: true,
    isPersonalVerificationCheckboxEnable: selectIsFttbPersonalVerificationCheckboxEnable(state)
  };
}), withRenderFlag)(LeaveYourPhonePopupWidget);